module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="tipping-tips-gamebar-container">\n	<div class="tips-info">\n		<div class="tipping-tip-details-inner">\n			<div class="data-column">\n				<div class="title">STREAK</div>\n				<div class="data-column">\n					<div class="value">'+
((__t=( streak ))==null?'':_.escape(__t))+
'</div>\n				</div>\n				\n			</div>\n			<div class="data-column hidden-mobile">\n				<div class="title">PLAYERS</div>\n				<div class="data-column">\n					<div class="value">\n						'+
((__t=( rank ))==null?'':_.escape(__t))+
'\n					</div>\n					<div class="data-total">\n						/'+
((__t=( active_users ))==null?'':_.escape(__t))+
'\n					</div>\n				\n				</div>\n			</div>\n			<div class="data-column hidden-mobile">\n				<div class="title">MARGIN TOTAL</div>\n				<div class="data-column">\n					<div class="value">'+
((__t=( total_margin ))==null?'':_.escape(__t))+
'</div>\n				</div>\n			</div>\n		</div>\n	</div>\n	<div class="tips-controls">\n		<a class="inner-element primary-btn js-save">save</a>\n	</div>\n</div>';
}
return __p;
};
